import { Event } from "@/models/Events.model";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import { FC, JSX } from "react";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
} from "react-international-phone";

const EventSingleUI: FC<Event> = ({
  name,
  location,
  address,
  country,
}): JSX.Element => {
  const eventCountry = defaultCountries.find((item) => {
    const parsedCountry = parseCountry(item);
    return parsedCountry?.iso2 === country;
  });

  return (
    <Flex direction="column" gap="3">
      <Heading as="h3" size="4">
        {name}
      </Heading>
      <Box>
        <Heading as="h4" size="2">
          {location}
        </Heading>
        <Text size="2" as="div" color="gray">
          {address}
        </Text>
        <Text size="2" as="div" color="gray">
          {eventCountry && (
            <Flex gap="1" align="center">
              <FlagImage size="16px" iso2={eventCountry[1]} />
              <Text size="2" as="span" color="gray">
                {eventCountry[0]}
              </Text>
            </Flex>
          )}
        </Text>
      </Box>
    </Flex>
  );
};

export default EventSingleUI;
